{
  "color": ["#7ac8ff", "#30b66e", "#ff80ff", "#ff5f5f", "#fdad44", "#0071c2", "#055523", "#bc2cbc", "#8c0000", "#550a00"],
  "backgroundColor": "rgba(255,255,255,1)",
  "textStyle": {
    "color": "#4C433E",
    "fontFamily": "Fellix, sans-serif"
  },
  "title": {
    "textStyle": {
      "color": "#26211f"
    },
    "subtextStyle": {
      "color": "#4c433e"
    }
  },
  "line": {
    "itemStyle": {
      "borderWidth": 1
    },
    "lineStyle": {
      "width": 4
    },
    "symbolSize": 4,
    "symbol": "Circle",
    "smooth": true
  },
  "radar": {
    "itemStyle": {
      "borderWidth": 1
    },
    "lineStyle": {
      "width": 2
    },
    "symbolSize": 4,
    "symbol": "Circle",
    "smooth": false
  },
  "bar": {
    "itemStyle": {
      "barBorderWidth": 0,
      "barBorderColor": "#ccc"
    }
  },
  "pie": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "scatter": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "boxplot": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "parallel": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "sankey": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "funnel": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "gauge": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    }
  },
  "candlestick": {
    "itemStyle": {
      "color": "#c23531",
      "color0": "#314656",
      "borderColor": "#c23531",
      "borderColor0": "#314656",
      "borderWidth": 1
    }
  },
  "graph": {
    "itemStyle": {
      "borderWidth": 0,
      "borderColor": "#ccc"
    },
    "lineStyle": {
      "width": 4,
      "color": "#aaaaaa"
    },
    "symbolSize": 4,
    "symbol": "emptyCircle",
    "smooth": false,
    "color": ["#7ac8ff", "#30b66e", "#ff80ff", "#ff5f5f", "#fdad44", "#0071c2", "#055523", "#bc2cbc", "#8c0000", "#550a00"],
    "label": {
      "color": "#eeeeee"
    }
  },
  "map": {
    "itemStyle": {
      "areaColor": "#eeeeee",
      "borderColor": "#444444",
      "borderWidth": 0.5
    },
    "label": {
      "color": "#000000"
    },
    "emphasis": {
      "itemStyle": {
        "areaColor": "rgba(255,215,0,0.8)",
        "borderColor": "#444444",
        "borderWidth": 1
      },
      "label": {
        "color": "rgb(100,0,0)"
      }
    }
  },
  "geo": {
    "itemStyle": {
      "areaColor": "#eeeeee",
      "borderColor": "#444444",
      "borderWidth": 0.5
    },
    "label": {
      "color": "#000000"
    },
    "emphasis": {
      "itemStyle": {
        "areaColor": "rgba(255,215,0,0.8)",
        "borderColor": "#444444",
        "borderWidth": 1
      },
      "label": {
        "color": "rgb(100,0,0)"
      }
    }
  },
  "categoryAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#4c433e"
    },
    "splitLine": {
      "show": false,
      "lineStyle": {
        "color": ["#ccc"]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
      }
    }
  },
  "valueAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#4c433e"
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": ["#e6d9d2"]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
      }
    }
  },
  "logAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#4c433e"
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": ["#e6d9d2"]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
      }
    }
  },
  "timeAxis": {
    "axisLine": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisTick": {
      "show": true,
      "lineStyle": {
        "color": "#4c433e"
      }
    },
    "axisLabel": {
      "show": true,
      "color": "#4c433e"
    },
    "splitLine": {
      "show": true,
      "lineStyle": {
        "color": ["#e6d9d2"]
      }
    },
    "splitArea": {
      "show": false,
      "areaStyle": {
        "color": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
      }
    }
  },
  "toolbox": {
    "iconStyle": {
      "borderColor": "#736761"
    },
    "emphasis": {
      "iconStyle": {
        "borderColor": "#4c433e"
      }
    }
  },
  "legend": {
    "textStyle": {
      "color": "#4c433e"
    }
  },
  "tooltip": {
    "backgroundColor": "#FFCDFF",
    "borderWidth": 0,
    "padding": [16, 24],
    "textStyle": {
      "color": "#23000D"
    },
    "axisPointer": {
      "lineStyle": {
        "color": "#4C433E",
        "width": 1
      },
      "crossStyle": {
        "color": "#4C433E",
        "width": 1
      }
    }
  },
  "timeline": {
    "lineStyle": {
      "color": "#293c55",
      "width": 1
    },
    "itemStyle": {
      "color": "#293c55",
      "borderWidth": 1
    },
    "controlStyle": {
      "color": "#293c55",
      "borderColor": "#293c55",
      "borderWidth": 0.5
    },
    "checkpointStyle": {
      "color": "#e43c59",
      "borderColor": "#c23531"
    },
    "label": {
      "color": "#293c55"
    },
    "emphasis": {
      "itemStyle": {
        "color": "#a9334c"
      },
      "controlStyle": {
        "color": "#293c55",
        "borderColor": "#293c55",
        "borderWidth": 0.5
      },
      "label": {
        "color": "#293c55"
      }
    }
  },
  "visualMap": {
    "color": ["#bf444c", "#d88273", "#f6efa6"]
  },
  "dataZoom": {
    "backgroundColor": "rgba(47,69,84,0)",
    "dataBackgroundColor": "rgba(47,69,84,0.3)",
    "fillerColor": "rgba(167,183,204,0.4)",
    "handleColor": "#a7b7cc",
    "handleSize": "100%",
    "textStyle": {
      "color": "#333333"
    }
  },
  "markPoint": {
    "label": {
      "color": "#eeeeee"
    },
    "emphasis": {
      "label": {
        "color": "#eeeeee"
      }
    }
  }
}
